import { render, staticRenderFns } from "./addBudgetPerformancePermission.vue?vue&type=template&id=b578f588&scoped=true"
import script from "./addBudgetPerformancePermission.vue?vue&type=script&lang=js"
export * from "./addBudgetPerformancePermission.vue?vue&type=script&lang=js"
import style0 from "./addBudgetPerformancePermission.vue?vue&type=style&index=0&id=b578f588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578f588",
  null
  
)

export default component.exports